import React, {Component} from "react";
import tos from "./tos.txt"

export default class Footer extends Component {
    render() {
        return <div className={"footer"}>
            <a href={tos}>Terms & Conditions</a> | <span>© 2021 Telos Outdoor LLC.</span>
        </div>
    }
}
